import React from 'react';
import { Col, Empty, Modal, Row, Spin } from 'antd';
import Sortable from 'react-sortablejs';
import CreativeSelect from '../../../containers/campaign/CreativeSelect';
import CreativeSingle from '../../../containers/campaign/CreativeSingle';

const CreativeListModal = ({
  ad,
  activeProduct,
  loading,
  handleSubmit,
  submitting,
  onCancelCreativeModal,
  creativeList,
  visibleCreativeModal,
  removeCreative,
  handleMoveCreatives,
}) => (
  <Modal
    destroyOnClose
    confirmLoading={submitting}
    onCancel={onCancelCreativeModal}
    onOk={handleSubmit}
    width={900}
    bodyStyle={{
      backgroundColor: 'rgb(231, 231, 231)',
    }}
    okText="Update"
    title={
      <Row type="flex" align="top">
        <Col>
          {activeProduct.name}
          <br />
          <small>{ad.name}</small>
        </Col>
        <Col offset={1}>
          <CreativeSelect activeList={creativeList} multiple handleSubmit={handleSubmit} />
        </Col>
      </Row>
    }
    visible={visibleCreativeModal}
  >
    {!creativeList.length && <Empty description="No Creatives" />}

    <Spin spinning={loading}>
      <form onSubmit={handleSubmit}>
        {!creativeList.length ? null : (
          <Sortable onChange={handleMoveCreatives}>
            {creativeList.map(creative => (
              <CreativeSingle
                key={creative.creative_id}
                removeCreative={() => {
                  removeCreative(activeProduct.product_id, creative.creative_id);
                }}
                creative={creative}
                creative_id={creative.creative_id}
              />
            ))}
          </Sortable>
        )}
      </form>
    </Spin>
  </Modal>
);

CreativeListModal.defaultProps = {
  showEdit: {},
};

export default CreativeListModal;
